export default __webpack_public_path__ + "static/media/dice.b84ad116.png";